import { Text, Flex, Heading } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';

import { ChakraNextResponsiveImage } from '@/components/ui/shared/image/ChakraNextResponsiveImage';
import { IThinProfile } from '@/resources/upgrade/ThinProfile';

export const SpeakerCard: FC<{ profile: IThinProfile }> = ({ profile }) => {
  return (
    <Flex
      as={NextLink}
      href={`/speakers/${profile.link_slug}`}
      passHref
      textAlign="center"
      alignItems="center"
      p="5"
      flexDir="column"
      w="240px"
      boxSizing="border-box"
      _hover={{
        boxShadow: 'card2xl',
      }}
      cursor="pointer"
    >
      <ChakraNextResponsiveImage
        borderRadius="full"
        overflow="hidden"
        w="200px"
        h="200px"
        src={profile.square_avatar}
        alt={profile.first_name}
      />
      <Heading fontSize="2xl" mt="9">
        {profile.full_name}
      </Heading>
      {profile.institution && (
        <Text fontSize="sm" color="gray.800" mt="2">
          {profile.institution}
        </Text>
      )}
    </Flex>
  );
};
